import {get} from '@/utils/request';

const getPayCompanyInfo = function (){
    return get('/api/publicAccount/selPubliceAccount').then(res=>{return res.data}).catch(err=>console.log(err))
}

export {getPayCompanyInfo}
